import React, { useEffect, useState } from "react";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/EditBtn.svg";
import Button from "../../extra/Button";
import Pagination from "../../extra/Pagination";
import Table from "../../extra/Table";
import Searching from "../../extra/Searching";
import { connect, useDispatch, useSelector } from "react-redux";

import {
  getHashTagApi,
  deleteHashtag,
  addHashtag,
  updateHashtag,
} from "../../store/shorts/shorts.action";

import { warning } from "../../../util/Alert";
import { covertURl } from "../../../util/AwsFunction";
import UserImage from "../../../assets/images/8.jpg";
import $ from "jquery";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { useNavigate } from "react-router-dom";
import { loading } from "../../store/video/video.type";
import ToggleButton from "../../extra/ToggleButton";
import FeatureToggle from "../../extra/ToggleButton";
import white from "../../../assets/images/whiteStar.png";
import { CheckBox, LastPage } from "@mui/icons-material";
import { lime } from "@mui/material/colors";
import { colors } from "@mui/material";
import { getHashTag } from "../../store/video/video.action";
function ManageVideo(props) {
  const { startDate, endDate, multiButtonSelectData } = props;
  const dispatch = useDispatch();
  const [checkBox, setCheckBox] = useState();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(25);
  const [verificationRequests, setVerificationRequests] = useState();
  const [actionPagination, setActionPagination] = useState("delete");
  const [actionFilter, setActionFilter] = useState("All");
  const [actionEnteries, setActionEnteries] = useState("25");
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [search, setSearch] = useState();
  const [data, setData] = useState([]);
  const [showURLs, setShowURLs] = useState([]);
  const [showVideoURLs, setShowVideoURLs] = useState([]);
  const [flag, setFlag] = useState(false);
  const [hashtags, setHashtag] = useState("");
  const [feature, setFeature] = useState(false);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const navigate = useNavigate();

  const { videoData, totalVideo, totalHashtag, hashtagData } = useSelector(
    (state) => state.shorts
  );

  useEffect(() => {
    dispatch({
      type: loading,
      payload: {
        loading: true,
      },
    });
  }, [data]);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const update = () => {
    setFlag(!flag);
  };
  useEffect(() => {}, flag);
  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", UserImage);
    });
  });
  //filter Data
  const [filter, setFilter] = useState({
    filter1: "",
    filter2: "",
  });
  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };
  const handleSelectCheckData = (e, row) => {
    const checked = e.target.checked;

    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id)
      );
    }
  };
  const handleFeature = (e, row) => {
    const checked = e.target.checked;
    setFeature(checked);
  };
  const getFeature = (feature) => {
    setFeature(feature);
    return !feature;
  };
  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };
  const actionFilterHandle = (filter) => {
    if (filter === "Featured") {
      dispatch(getHashTagApi("featured", page, size));
    } else if (filter === "Not Featured") {
      dispatch(getHashTagApi("non-featured", page, size));
    } else {
      dispatch(getHashTagApi("all", page, size));
    }
  };
  const paginationSubmitButton = () => {
    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);

    if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          if (res.isConfirmed) {
            props.deleteHashtag(selectCheckDataGetId);
          }
        })
        .catch((err) => console.log(err));
    }
    if (actionPagination === "featured") {
      const selectCheckDataGetId = selectCheckData?.map((item) => ({
        uniqueVideoId: item?._id,
        feature: true,
      }));
      const data = warning();
      data
        .then((res) => {
          if (res.isConfirmed) {
            props.updateHashtag(selectCheckDataGetId, page, size);
          }
        })
        .catch((err) => console.log(err));
    }
    if (actionPagination === "not featured") {
      const selectCheckDataGetId = selectCheckData?.map((item) => ({
        uniqueVideoId: item?._id,
        feature: false,
      }));

      const data = warning();
      data
        .then((res) => {
          if (res.isConfirmed) {
            props.updateHashtag(selectCheckDataGetId, page, size);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handleDeleteHashtag = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            props.deleteHashtag(id);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (data) {
      fetchData();
      fetchVideoData();
    }
  }, [data]);

  const fetchData = async () => {
    if (!data || data.length === 0) {
      // Handle case when data is undefined or empty
      return;
    }

    const urls = await Promise.all(
      data?.map(async (item) => {
        const fileNameWithExtension = item?.image?.split("/").pop();
        const { imageURL } = await covertURl(
          "userImage/" + fileNameWithExtension
        );

        return imageURL;
      })
    );
    setShowURLs(urls);
  };

  const fetchVideoData = async () => {
    if (!data || data?.length === 0) {
      // Handle case when data is undefined or empty
      return;
    }

    const urls = await Promise.all(
      data &&
        data?.map(async (item) => {
          const fileNameWithExtension = item?.videoUrl?.split("/").pop();
          const { imageURL } = await covertURl(
            "Videos/" + fileNameWithExtension
          );

          return imageURL;
        })
    );
    setShowVideoURLs(urls);
  };

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const handleEdit = (row, type) => {
    console.log("handle Edit", OPEN_DIALOGUE, type, row);
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
        start: page,
        limit: size,
        startDate: startDate,
        endDate: endDate,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const videoMapData = [
    {
      Header: "checkBox",
      width: "20px",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },

    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "Hashtag",
      body: "uniqueId",
      Cell: ({ row }) => <span className="cursorPointer">{row?.hashTag}</span>,
    },
    {
      Header: "Feature Tag",
      width: "20px",
      Cell: ({ row }) => (
        <FeatureToggle
          type={"hashtag"}
          row={{
            uniqueVideoId: row._id,
            feature: row?.feature === undefined ? false : true,
          }}
          updateHashtag={props.updateHashtag}
          page={page}
          size={size}
          startDate={startDate}
          endDate={endDate}
        />
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button">
          <Button
            btnIcon={<EditIcon />}
            onClick={() => handleEdit(row, "editHashtag")}
          />
          <Button
            btnIcon={<TrashIcon />}
            onClick={() => handleDeleteHashtag(row)}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    setData(hashtagData);
  }, [hashtagData]);

  useEffect(() => {
    dispatch(getHashTagApi(filter, page, size));
    dispatch(getHashTag());
  }, [dispatch, page, size]);

  return (
    <div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className="row align-items-start">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "4px",
                marginTop: "5px",
              }}
            >
              Manage Tags
            </h5>
            <Searching
              addHashtag={addHashtag}
              start={page}
              limit={size}
              hashtags={hashtags}
              setHashtag={setHashtag}
              label={" Search for hashTag"}
              placeholder={"Search..."}
              data={hashtagData}
              type={"client"}
              setData={setData}
              onFilterData={handleFilterData}
              searchValue={search}
              customSelectDataShow={true}
              customSelectData={["Delete", "Featured", "Not Featured"]}
              customEnteriesData={["25", "50", "100", "150"]}
              actionPagination={actionPagination}
              setActionPagination={setActionPagination}
              actionEnteries={actionEnteries}
              setActionEnteries={setActionEnteries}
              paginationSubmitButton={paginationSubmitButton}
              typeIsTag={"TAG"}
              handleRowsPerPage={handleRowsPerPage}
              customeSelectDataEnteriesShow={true}
              //filter
              customeFilterData={["All", "Featured", "Not Featured"]}
              customFilterDataShow={true}
              actionFilter={actionFilter}
              setActionFilter={setActionFilter}
              handleFilterData={handleFilterData}
              actionFilterHandle={actionFilterHandle}
              //filter records
              filterType={"FilterTags"}
              firstField={true}
              firstFieldName={"Searching Tag"}
              secondField={false}
              secondFieldName={"Search Tag"}
              ModelName={"Searching Tag"}
              feature={true}
              options={false}
              setFilter={setFilter}
              hasActiveFilters={hasActiveFilters}
              setHasActiveFilters={setHasActiveFilters}
            />
          </div>
        </div>
        <Table
          data={data}
          mapData={videoMapData}
          serverPerPage={size}
          serverPage={page}
          handleSelectAll={handleSelectAll}
          selectAllChecked={selectAllChecked}
          type={"server"}
        />
        <div className="mt-3">
          <Pagination
            type={"server"}
            activePage={page}
            rowsPerPage={size}
            userTotal={totalHashtag}
            setPage={setPage}
            handleRowsPerPage={handleRowsPerPage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}
export default connect(null, {
  getHashTag,
  updateHashtag,
  deleteHashtag,
  addHashtag,
})(ManageVideo);
